import { useState } from "react";
import { createTradingAccount } from "./TradingAccountService";

export default function TradingAccountForm({ onSaved }) {
  const [brokerName, setBrokerName] = useState("");
  const [accountNumber, setAccountNumber] = useState("");
  const [baseCurrency, setBaseCurrency] = useState("INR");
  const [active, setActive] = useState(true);
  const [comment, setComment] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    await createTradingAccount({
      brokerName,
      accountNumber,
      baseCurrency,
      isActive: active,
      comment,
    });
    setBrokerName("");
    setAccountNumber("");
    setBaseCurrency("INR");
    setActive(true);
    setComment("");
    if (onSaved) onSaved();
  };

  return (
    <form className="card stack-form" onSubmit={submit}>
      <h3>Add Trading Account</h3>
      <input
        value={brokerName}
        onChange={(e) => setBrokerName(e.target.value)}
        placeholder="Broker name"
        required
      />
      <input
        value={accountNumber}
        onChange={(e) => setAccountNumber(e.target.value)}
        placeholder="Account number"
      />
      <input
        value={baseCurrency}
        onChange={(e) => setBaseCurrency(e.target.value)}
        placeholder="Base currency"
      />
      <input
        value={comment}
        onChange={(e) => setComment(e.target.value)}
        placeholder="Comment"
      />
      <label className="inline-checkbox">
        <input
          type="checkbox"
          checked={active}
          onChange={(e) => setActive(e.target.checked)}
        />
        Active
      </label>
      <button className="btn btn-primary" type="submit">
        Save
      </button>
    </form>
  );
}
